import {
  SAVE_ALL_FOM_MASTIC,
  ACTION_GET_FOM_RELATION,
  FOM_MASTIC_SEARCH,
} from "Stores/actionTypes";
import StatusHandler from "Helpers/StatusHandler";
import FomMasticService from "Services/http/endpoints/properties/FomMasticService";
import { read } from "Helpers/LocalStorage";
import { analyzePrice } from "Helpers/analyzePrice";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const GetAllFomMastik = (params) => {
  return async (dispatch) => {
    try {
      const response = await FomMasticService.GetAllFomMastik(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = analyzePrice(response.data.Value);
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: ((page - 1 ) * limit) + index + 1,
          };
        });
        dispatch({
          type: SAVE_ALL_FOM_MASTIC,
          fomMastikData: updatedData,
          fomMastikDataPagination:response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const EditPriceFomMastik = (data) => {
  return async (dispatch) => {
    try {
      const response = await FomMasticService.EditPriceFomMastik(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('changePriceSuccess'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const EditFomMastik = (data) => {
  return async (dispatch) => {
    try {
      const response = await FomMasticService.EditFomMastik(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_editing_of_foam_and_mastic_was_done_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const InsertFomMastikData = (data) => {
  return async (dispatch) => {
    try {
      const response = await FomMasticService.InsertFomMastikData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_new_foam_and_mastic_was_successfully_registered'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteFomMastik = (data) => {
  return async (dispatch) => {
    try {
      const response = await FomMasticService.deleteFomMastik(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Foam_and_mastic_were_successfully_removed'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
          };
          dispatch(getRelationFom(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableFomMastik = (data) => {
  return async (dispatch) => {
    try {
      const response = await FomMasticService.disableFomMastik(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationFom = (params) => {
  return async (dispatch) => {
    try {
      const response = await FomMasticService.getRelationFom(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_FOM_RELATION,
          dataRelationFomMastik: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeFomMastikSearch = (fomMastikDataSearch) => (dispatch) => {
  dispatch({
    type: FOM_MASTIC_SEARCH,
    fomMastikDataSearch: fomMastikDataSearch,
  });
}